import { memo } from "react";
import { makeStyles } from "components/providers/makeStyles";
import { Link } from "react-router-dom";
import { Button, Container } from "@mui/material";
import { T } from "../../util/t";

import { useIsInViewport } from "../../../hooks/useIsInViewport";
import { useIsEmbedded } from "hooks/useIsEmbedded";

export const RegisterButton = ({ event, buttonText = "Register" }) => {
    const [ref, isInViewport] = useIsInViewport();
    return <MemoedRegisterButton isInViewport={isInViewport} buttonRef={ref} event={event} buttonText={buttonText} />;
};

const useStyles = makeStyles((theme, { isEmbedded }) => ({
    button: {
        "&": {
            [theme.breakpoints.down("md")]: {
                width: "100%",
            }
        },
    },
    staticButton: {
        margin: theme.spacing(2, 0, 3, 0),
        "&": {
            [theme.breakpoints.down("md")]: {
                margin: theme.spacing(1, 0, 2, 0),
            }
        }
    },
    floatingButton:  {
        position: "fixed",
        zIndex: 1,
        left: 0,
        right: 0,
        bottom: theme.spacing(isEmbedded ? 5 : 1),
    }
}));

export const MemoedRegisterButton = memo(({ isInViewport, buttonRef, event, buttonText }) => {
    const isEmbedded = useIsEmbedded();
    const classes = useStyles({ isEmbedded });

    const registerButton = (
        <Button
            component={Link}
            to={`/events/${event.id}/registration`}
            variant="contained"
            className={classes.button}>
            <T>{buttonText}</T>
        </Button>
    );

    return (
        <>
            <div ref={buttonRef} className={classes.staticButton}>{registerButton}</div>
            {!isInViewport && <Container className={classes.floatingButton}>{registerButton}</Container>}
        </>
    );
});
